module.exports = __webpack_public_path__ + "static/video-0e1c10ab614bc56fad2ed06c08319088.mp4";